module.exports = __webpack_public_path__ + "img/PT881.40d00f4b.png";